import { FleetPanel } from '@/features/fleet/FleetPanel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/fleet')({
  component: FleetPanel,
});
